import Modal from "@material-ui/core/Modal/Modal";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { Text } from "components/Typography/text.styled";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import {
  CompanyCalendarGigDto,
  CompanyCalendarTimereport,
} from "model/Calendar";
import { CompanyGig, GigType } from "model/Gig";
import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { OrganizationalStructureState } from "web-apps/company/stores/organizationalStructureStore/organizationalStructureStore.reducers";
import { GigFormModal } from "../../gig/gigForm/gigFormModal.component";
import { NotFilledGigModalBody, ShiftCell } from "../weeklyCalendar.styled";

type Props = {
  name: string;
  compactView: boolean;
  timeReport: CompanyCalendarTimereport | undefined;
  keyId: number;
  dashboard: boolean | undefined;
  gigData: CompanyCalendarGigDto;
  shift: number;
};

export const getWorkGroupName = (
  gigData: CompanyCalendarGigDto | CompanyGig,
  state: OrganizationalStructureState
): string | null => {
  const id = gigData?.workGroupId;
  if (id == null) return null;

  const allGroups = (state.structure?.entities ?? [])
    .flatMap((e) => e.units ?? [])
    .flatMap((u) => u.workGroups ?? []);

  return allGroups.find((g) => g.id === id)?.name ?? null;
};

export const WithdrawnCalendarGig: React.FC<Props> = ({
  name,
  compactView,
  timeReport,
  keyId,
  dashboard,
  gigData,
  shift,
}) => {
  const { t } = useTranslation();
  const clickedShift = gigData.shifts.find((s) => s.id === shift);
  const [showCreateGigModal, setShowCreateGigModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const tooltipContent = compactView
    ? `${moment(timeReport?.startTime).format("HH:mm") ?? ""} - ${
        moment(timeReport?.endTime).format("HH:mm") ?? ""
      }`
    : name;

  return (
    <>
      <ShiftCell
        key={keyId}
        backgroundColor={Color.LightWarning}
        data-tooltip-id={"worker-name"}
        data-tooltip-content={tooltipContent}
        onClick={() => {
          setShowModal(true);
        }}
      >
        {!compactView ? (
          <Text color={Color.White}>
            {timeReport
              ? `${moment(timeReport.startTime).format("HH:mm")} - ${moment(
                  timeReport.endTime
                ).format("HH:mm")}`
              : ""}
          </Text>
        ) : (
          <Text fontSize={FontSize.Small} color={Color.White}>{`${
            name.length > 6 && dashboard
              ? `${name.slice(0, 6)}...`
              : name
              ? `${name}`
              : dashboard && !name
              ? t(t("CalendarCompany.NotFilled")).slice(0, 7) + "..."
              : t(t("CalendarCompany.NotFilled"))
          }`}</Text>
        )}
        {!compactView ? (
          <Text color={Color.White}>{tooltipContent}</Text>
        ) : (
          <Tooltip
            id={"worker-name"}
            place="top"
            style={{
              backgroundColor: Color.White,
              color: Color.MidnightBlue,
              fontFamily: FontFamily.MontserratRegular,
              boxShadow: "0 4px 10px 0 rgba(0, 0, 0, 0.1)",
            }}
          />
        )}
      </ShiftCell>

      {showCreateGigModal && clickedShift && (
        <GigFormModal
          type={GigType.SOLO}
          shifts={[clickedShift]}
          showGigFormModal={showCreateGigModal}
          setShowGigFormModal={setShowCreateGigModal}
        />
      )}

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <NotFilledGigModalBody>
          <Text
            fontFamily={FontFamily.MontserratSemiBold}
            color={Color.PitchBlack}
            fontSize={FontSize.H3}
          >
            {t("CalendarCompany.Withdrawn")}
          </Text>
          <Text
            fontFamily={FontFamily.MontserratRegular}
            color={Color.PitchBlack}
          >
            {t("CalendarCompany.CreateNewReplacementShift")}
          </Text>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "40px",
            }}
          >
            <ButtonStyled
              backgroundColor={Color.ModernGreen}
              onClick={() => {
                setShowCreateGigModal(true);
                setShowModal(false);
              }}
            >
              {t("CalendarCompany.Create")}
            </ButtonStyled>
          </div>
        </NotFilledGigModalBody>
      </Modal>
    </>
  );
};
